// For Admin CSR pages and related data

import { defineStore } from 'pinia'
import { ref } from 'vue'

import type { Course } from '@/javascript/interfaces'

import api from '../services/api'
import { getContentPackageFolderList } from '../services/packages'
import type { ContentPackage, ContentPackageFolder } from '../services/packages/interfaces'
import type { Certification, Curriculum } from '../services/trainingCurriculums/interfaces'
import { useNotificationStore } from './NotificationStore'

export const usePackagesAndProgramsStore = defineStore('packagesAndPrograms', () => {
	// State
	const allAvailablePackagesAndFolders = ref<ContentPackageFolder[]>([])
	const allFolders = ref<ContentPackageFolder[]>([])
	const certifications = ref<Certification[]>([])
	const contentPackages = ref<ContentPackage[]>([])
	const courses = ref<Course[]>([])
	const curriculums = ref<Curriculum[]>([])
	const notificationStore = useNotificationStore()
	const selectedFolder = ref<ContentPackageFolder | undefined>(undefined)

	// Actions
	const getAllContentPackageFolders = async () => {
		try {
			const response = await getContentPackageFolderList(api)

			allFolders.value = response
		} catch (error) {
			const errorMessage = error instanceof Error ? error.message : String(error)

			notificationStore.onHandleErrorMessages({ error: { message: errorMessage } })
		}
	}

	return {
		// State
		allAvailablePackagesAndFolders,
		allFolders,
		certifications,
		contentPackages,
		courses,
		curriculums,
		selectedFolder,

		// Actions
		getAllContentPackageFolders,
	}
})
